export default __webpack_public_path__ + "static/header.colompac.uebersicht-c4d7e0c93b4f25a3e22033bc66fc7df4.png";